export const FETCH_COMPRESSION_LOG = 'FETCH_COMPRESSION_LOG';
export const FETCH_WATCH_FOLDER_LOG = `FETCH_WATCH_FOLDER_LOG`;
export const FETCH_DOCUMENTS_LOG =`FETCH_DOCUMENTS_LOG`;
export const FETCH_DUPLICATE_LOG =`FETCH_DUPLICATE_LOG`;
export const FETCH_DOCUMENTEVENT_LOG =`FETCH_DOCUMENTEVENT_LOG`;
export const FETCH_CORRUPT_FILE_LOG =`FETCH_CORRUPT_FILE_LOG`;
